"use client";

import { PageHero } from "@widgets/page-hero";

import cardsGrid from "@shared/ui/cards-grid/cards-grid.module.scss";
import { FilterPaginationContainerWithMultiBadges } from "@shared/ui/filter-pagination-container-with-multi-badges";
import { PointCard } from "@shared/ui/point-card";

import { getCurrentAccommodationsPoint } from "../api";
import type {
  AccommodationsBadgeType,
  AccommodationsPageType,
  AccommodationsPoints,
  AccommodationsType,
} from "../model/types";

import s from "./accommodations-page.module.scss";

export type AccommodationsPageProps = {
  filters: AccommodationsType[];
  badges: AccommodationsBadgeType[];
  content: AccommodationsPoints;
  hero: AccommodationsPageType;
};

export const AccommodationsPage = (props: AccommodationsPageProps) => {
  const { filters, badges, content, hero } = props;

  return (
    <main className={s.root}>
      {hero?.titleWithIcon && (
        <PageHero
          variant="primary"
          textColor="brown"
          title={hero?.titleWithIcon}
        />
      )}
      <FilterPaginationContainerWithMultiBadges
        initialContent={content}
        filters={filters}
        badges={badges.map((b) => ({
          uid: b.uid,
          label: b.type,
          accommodations_points: b.accommodations_points,
        }))}
        badgesFilterKey="badges"
        fetchFunction={getCurrentAccommodationsPoint}
        mapTo="accommodations"
        renderCard={(card) => (
          <PointCard
            key={card.uid}
            href={`/accommodations/${card.uid}`}
            title={card.title}
            description={card.description}
            location={card.location}
            phone={card.phone}
            photos={card.photos}
            clampDescriptionOnMobile
            filters={
              card.accommodations_type
                ? [
                    {
                      uid: card.accommodations_type.uid,
                      label: card.accommodations_type.type,
                    },
                  ]
                : []
            }
            badges={(card.accommodations_badge_types || []).map((b) => ({
              uid: b.uid,
              label: b.type,
            }))}
            overlayIcon={{ name: "bed", fillColor: "violet" }}
          />
        )}
        paginationThreshold={6}
        cardsClassName={cardsGrid.root}
        sectionClassName={s.section}
        filterProps={{ dropdownFieldLabel: "Локация" }}
      />
    </main>
  );
};

AccommodationsPage.displayName = "AccommodationsPage";
